module.exports = __webpack_public_path__ + "img/product1-1.1f79c9cc.png";